export default __webpack_public_path__ + "static/media/Vector.3be42963.svg";